export const RELANCE_CREATE_RESET = "RELANCE_CREATE_RESET";
export const RELANCE_CREATE_SET_CREATED = "RELANCE_CREATE_SET_CREATED";
export const RELANCE_CREATE_SET_ERROR = "RELANCE_CREATE_SET_ERROR";
export const RELANCE_CREATE_SET_VIOLATIONS = "RELANCE_CREATE_SET_VIOLATIONS";
export const RELANCE_CREATE_TOGGLE_LOADING = "RELANCE_CREATE_TOGGLE_LOADING";
